var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return !_vm.hiddenGlobalNav ? _c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "logo",
    on: {
      "click": _vm.goHome
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logo-3.png"),
      "alt": "logo"
    }
  })]), _c('NavMenu'), _c('div', {
    staticClass: "user",
    on: {
      "mouseenter": _vm.subNavShow,
      "mouseleave": _vm.subNavShow
    }
  }, [_c('div', {
    staticClass: "head"
  }, [_vm.head ? _c('img', {
    attrs: {
      "src": _vm.head,
      "alt": "head"
    }
  }) : _vm._e()]), _c('div', [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.userInfo.teacherName || '游客'))]), _c('div', {
    staticClass: "school"
  }, [_vm._v(_vm._s(_vm.userInfo.schoolName || '游客'))])]), _c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.navShow,
      expression: "navShow"
    }],
    staticClass: "subnav"
  }, [_c('div', {
    staticClass: "column",
    on: {
      "click": _vm.set
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/home/set.png"),
      "alt": "set"
    }
  })]), _c('div', [_vm._v("账号设置")])]), _c('div', {
    staticClass: "column",
    on: {
      "click": _vm.logout
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/home/logout.png"),
      "alt": "logout"
    }
  })]), _c('div', [_vm._v("退出登录")])])])])], 1)], 1)]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };